// Identity helpers that pin the options generic so `pages`, `homeSections`
// and `brand(…, options)` are checked exhaustively (§4.2).

import type { OptionsSchema } from './options'
import type { SiteTemplate, SiteTemplateManifest } from './types'

export const defineTemplate = <const S extends OptionsSchema>(t: SiteTemplate<S>): SiteTemplate<S> => t
export const defineManifest = <const S extends OptionsSchema>(m: SiteTemplateManifest<S>): SiteTemplateManifest<S> => m
